import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { QrCodeLinkPayload, QrCodeLinkResponse } from '../interfaces/qrcode.interface';

@Injectable({
  providedIn: 'root'
})
export class NiboService {
  constructor(private httpClient: HttpClient) {}

  public getGoNiboUrl(url: string): Observable<string> {
    return this.httpClient.post<{shorterUrl: string}>(`${environment.sources.goNibo}`, { url }).pipe(map(({shorterUrl}) => shorterUrl));
  }

  public getQrCodeLink(accountantId: string, qrCodePayload: QrCodeLinkPayload) {
    const headers = {
      'Content-Type': 'application/json'
    };

    return this.httpClient.post<QrCodeLinkResponse>(`${environment.sources.goNibo}/${accountantId}`, qrCodePayload, {
      headers
    });
  }
}
